'use es6';

import { EMPTY_OBJECT } from "../../../internal/@base-ui/utils/empty";
import { DISABLED_TRANSITIONS_STYLE } from "./constants.js";
export function getDisabledMountTransitionStyles(transitionStatus) {
  return transitionStatus === 'starting' ? DISABLED_TRANSITIONS_STYLE : EMPTY_OBJECT;
}